<template>

    <div class="privacyPolicy-container " v-wechat-title="'隱私政策'">
        <!--頂部欄-->
        <div class="top-nav-container">
            <span>隱私政策</span>
            <span @click="backClick" style="position: absolute;left: 10px">返回</span>
        </div>
        
        <div class="content-container">
            <p>
                香港立異科技有限公司（以下簡稱&ldquo;立異&rdquo;或&ldquo;我們&rdquo;）尊重並保護立異網站b.mysread.com與立異應用的用戶個人資訊。我們將按照本隱私政策（以下簡稱&ldquo;本政策&rdquo;）收集、使用、存儲及共用用戶（以下簡稱為&ldquo;您&rdquo;）的個人資訊。&ldquo;立異應用&rdquo;是指完香港立異科技有限公司旗下產品&ldquo;立異&rdquo;以及&ldquo;前進吧!偶像少女&rdquo;與任何網站以及後續可能開通的其他網站及其他終端應用程式，前述網站及終端可單稱或並稱立異應用。本政策包含了我們收集、存儲、保護、使用和共用您的個人資訊的條款，我們建議您完整地閱讀本政策，在需要時，按照本政策的指引，作出您認為適當的選擇。</p>
            <p>
                如果您不同意本政策的任何內容，我們將無法為您提供立異網站以及立異應用的服務（以下簡稱&ldquo;服務&rdquo;），您應立即停止使用我們的服務。當您同意使用我們的立異應用服務時，即表示您已同意我們按照本政策來收集、存儲、使用和分享您的相關資訊。當本政策進行更新後，我們會及時在立異應用發佈最新版本。如您不同意本政策，我們將無法繼續為您提供服務。</p>
            <p>
                我們根據合法、正當、必要的原則，僅收集實現產品功能所必要的資訊。</p>
            <p>
                我們提供如下功能和服務時，可能會收集、儲存和使用下列與您有關的資訊。</p>
            <p>
                如果您不提供相關資訊，您可能無法註冊成為我們的用戶或無法享受我們提供的某些產品或服務，或者無法達到使用相關服務擬達到的效果。</p>
            <p>
                1.註冊註意事項</p>
            <p>
                歡迎任何人下載或者流覽。然而，如果您想參與應用的不同部分，例如在網上充值，您就必須註冊。如果您在居住地點屬未成年人士，就必須由父母或合法監護人（必須符合法定資格）代表您詳閱、瞭解並同意本規範之所有內容及其後修改變更後再完成充值程式。</p>
            <p>
                2.帳號及密碼</p>
            <p>
                2.1您在註冊成為會員時，需設定壹組帳號、密碼。您瞭解帳號壹旦設定，就不可再變更；而密碼則可以在本服務上進行變更。</p>
            <p>
                2.2本公司（含客服人員）絕不會主動詢問妳的密碼，您就您的帳號及密碼的保管負全責；您同意您不會將帳號、密碼轉讓或出借予他人使用。</p>
            <p>
                2.3虛擬貨幣屬於特殊商品，請閣下仔細查詢妳正要儲值的金額有沒有錯誤</p>
            <p>
                本網站壹經儲值，即表示同意香港立異科技有限公司所有條款與細則，</p>
            <p>
                您儲值存入帳號，不得要求兌回現金或退費。</p>
            <p>
                2.4若您發現您的帳號遭人非法使用或有任何異常破壞使用安全的情形時，您應立即通知本公司；但若是因為您的保管疏忽，而導致帳號、密碼遭他人非法使用時，本公司將不負責處理。使用者對於其個人資料、付款資料（包含信用卡資料）及會員密碼等，應妥善保管並避免外泄。上述您所提供之資訊及密碼，為消費者在使用『立異會員服務』進行交易時之重要認證依據。</p>
            <p>
                2.5您可以通過app內的聯繫客服方式，聯繫官方客服人員註銷賬號，如您對立異有任何意見或建議，亦可以通過前述方式投訴舉報。</p>
            <p>
                本公司將依照您所提供之資訊進行包括公司之認證、消費交易紀錄之保存及認證訊息之發送、會員訊息或相關活動之告知、或未來收取使用費用之依據，您有義務妥善保管您的身分資料之機密及安全，不得洩漏給任何第三人知悉。</p>
            <p>
                3.服務與限制</p>
            <p>
                3.1所有本服務網站、應用內之所有記錄等，皆屬本公司所有；但您明瞭且知悉所有資訊、數據、原件、軟體、音樂、聲響、照片、圖片、錄影帶、訊息或其他素材(以下統稱為內容)，無論是公開貼文或是私下透過本服務傳遞者，皆由原發表人自負壹切責任。為了提供更好的服務品質，需硬體設備變更或調整時，您同意本公司可以將您使用的帳號及相關記錄轉移至其他位置，您也承諾願意配合進行相關設定以因應此類調整。您必須使用正當的方式上線，如您使用違法的方式上線，本公司對您的帳號將保留限制的權利；若您攻擊本公司伺服器，本公司即有權關閉您的IP 地址，並刪除您的相關紀錄。您若對於本服務處理您帳號的相關記錄有疑問，您必須提出與您帳號相符的證明資料並請提供您的真實姓名、身分證字型大小、連絡電話及Email等訊息向本公司申請查核‧</p>
            <p>
                3.2國際使用之特殊警示：您理解互聯網具有全球性，而同意遵守所有您原籍國或行為地國家關於線上行為和可接受內容所適用的法律，法規和規章。</p>
            <p>
                4.個人身分資料之保護</p>
            <p>
                本公司除因配合司法機關要求而提供上列之個人資訊外，將依照現行個人資料保護法之規定，在未經您本人同意的狀況下，本公司所獲得關於您的各項個人資料都將保密。</p>
            <p>
                5.智慧財產權</p>
            <p>
                您同意尊重智慧財產權。本服務網站之所有內容及所使用之系統、程式、檔案、網頁、軟體、資訊、或圖文等資料，均由本公司或其他權利人依法擁有其智慧財產權。</p>
            <p>
                未經本公司或其他權利人事前書面許可，任何人不得重制、複製、轉載、使用、引用、修改、改作、衍生、公開播放、散佈、發行、展示發表、執行還原工程、 解編譯或反組譯。違者，您應自負完全民、刑事法律責任並應對本公司負損害賠償責任（包括但不限於律師費及訴訟費用等）。</p>
            <p>
                未經本公司事前書面許可，您同意並保證不會使用任何方式，來對本服務及本服務網站的正常運作或任何正於本服務網站上進行的相關交易進行幹擾、企圖幹擾、監控、或增加任何不合理或不相稱的負荷。違者，您須自負完全民、刑事法律責任並應對本公司負損害賠償責任（包括但不限於律師費及訴訟費用等）。</p>
            <p>
                6.系統中斷或故障等其他限制</p>
            <p>
                本服務有時會因受幹擾、或外部線路、或天災等不可抗力、及各種軟、硬體等問題，可能會出現服務中斷或故障等狀況，並將造成您使用上的不便、資料喪失、錯誤或遭人為篡改或其他經濟損失等情形。您於使用本服務時宜採取自我防護措施。本公司對於您因此使用或因此無法使用本服務而造成的損害，不負任何賠償責任。</p>
            <p>
                7.本公司得不為通知並保留隨時修改或暫時提供本服務(或其中壹部)之權利。您同意本公司對於任何修改或暫停本服務之情形對於您或第三人不負任何責任。本公司或使用者有下列情事發生時，本線上服務自動終止：</p>
            <p>
                7.1定期檢查或施工、軟硬體之更新等，即暫停服務，本公司將儘快完成維修維護動作。</p>
            <p>
                7.2如伺服器遭到任何形式之破壞，無法正常運作時。</p>
            <p>
                7.3 ISP 網路線路傳輸品質不良，或其他透過網際網路連結至本公司伺服器之動作發生滯礙等情形。</p>
            <p>
                7.4天災、地變如水災、火災、地震等人力不可抗拒之因素。</p>
            <p>
                8.您的責任與義務</p>
            <p>
                您承諾基於合法的目的並以合法的方式使用本服務及本服務網站，您對於您公佈於本服務及本服務網站或透過本服務及本服務網站傳輸的壹切內容負全責。</p>
            <p>
                您承諾遵守您所屬國家的相關法規及壹切國際網際網路之規定與慣例。您同意並保證不公布或傳送任何誹謗、不實、威脅、不雅、猥褻、不法、侵害他人智慧財產權、或違反公序良俗的資訊或內容於本服務及本服務網站上。您同意並保證不利用本服務及本服務網站從事本公司有正當理由認為不適當之行為，如濫發廣告郵件等。</p>
            <p>
                您同意遵守本服務網站客服中心之公告。您的行為若違反本規範或任何法令，您同意本公司得隨時停止您使用本公司服務之權利，且本公司不需對任何第三人承擔責任，本公司並得立即拒絕或移除您公佈於本服務及本服務網站或透過本服務及本服務網站傳輸的壹切內容。</p>
            <p>
                立異保留修改所有條款及細則或終止推廣之權利而毋須事先通知。</p>
            <p>
                如有任何爭議，香港立異科技有限公司將保留最終決定權。</p>
        </div>
    </div>

</template>

<script>
export default {
    name: "PrivacyPolicyVue",
    data() {
        return {};
    },

    methods: {
        //返回
        backClick: function () {
            this.$router.go(-1);
        },
    },

    created() {},
};
</script>

<style scoped>
.privacyPolicy-container {
    max-width: 480px;
    min-height: 100vh;
    margin: 0 auto;
    border: 1px solid lightgoldenrodyellow;
    background-color: white;
}

.content-container{
        margin-top: 70px;
        text-align: left;
        margin-left: 10px;
        margin-right: 10px;
}

.content-container p{
        font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/PrivacyPolicyVue.vue